module.exports = __webpack_public_path__ + "img/9788950936518.9b13268f.jpg";